// export default Home;
import { useOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect } from "react";
import { Button, Header } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import config from "./config";
import "./loading.css";

const Home = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);

  const [state, setState] = useState({
    redirect: false,
  });

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
    } else {
      oktaAuth.getUser().then((info) => {
        setUserInfo(info);
        setState({ redirect: true, theme: info.theme });
      });
    }
    console.log("redirect", state.redirect);
    console.log("theme", state.theme);
  }, [authState, oktaAuth]); // Update if authState changes

  const login = async () => {
    await oktaAuth.signInWithRedirect();
  };

  if (!authState) {
    return (
      <div class="lds">
        <div class="lds-text">
          <p>Preparing for take-off!</p>
        </div>

        <div class="lds-default">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div>
        {
          <div class="lds">
            <div class="lds-text">
              <p>Preparing for take-off!</p>
            </div>

            <div class="lds-default">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        }

        {state.redirect &&
          state.theme === config.redirect.redirectHomePortalTheme && (
            <Redirect to="/redirect/portal" />
          )}

        {state.redirect &&
          state.theme === config.redirect.redirectLuxuryPortalTheme && (
            <Redirect to="/redirect/luxury" />
          )}

        {state.redirect &&
          state.theme !== config.redirect.redirectHomePortalTheme &&
          state.theme !== config.redirect.redirectLuxuryPortalTheme && (
            <Redirect to="/redirect/agent-login" />
          )}

        {!authState.isAuthenticated && (
          <div>
            <Button id="login-button" primary onClick={login}>
              Login
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default Home;
